<template>
  <a-drawer
    :closable="false"
    @close="onClose"
    :visible="visible"
    width="60%"
    :wrapClassName="getWrapClassName"
    getContainer=".layout-wapper"
    :zIndex="zIndex"
    :maskClosable="maskClosable"
    :destroyOnClose="destroyOnClose"
  >
    <a-spin :spinning="spin">
      <a-row
        class="header"
        type="flex"
        align="middle"
        justify="space-between"
      >
        <!-- 抽屉标题 -->
        <a-col class="title">{{title}}</a-col>
        <!-- 头部右边操作插槽 -->
        <a-col>
          <slot name="operate"></slot>
        </a-col>
      </a-row>
      <div class="base-drawer__body">
        <slot></slot>
      </div>
    </a-spin>
  </a-drawer>
</template>

<script>
export default {
  name: 'BindRelationDrawer',
  data() {
    return {};
  },
  props: {
    // 控制抽屉出现
    visible: {
      type: Boolean,
      default: false,
    },
    // 点击遮罩是否允许关闭
    maskClosable: {
      type: Boolean,
      default: true,
    },
    // 关闭时销毁 Drawer 里的子元素
    destroyOnClose: {
      type: Boolean,
      default: true,
    },
    zIndex: {
      type: Number,
      default: 990,
    },
    // 抽屉标题
    title: {
      type: String,
    },
    // 抽屉spin显示控制
    spin: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    getWrapClassName() {
      let className = 'base-drawer';
      if (this.offset) className += ' offset';
      return className;
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less">
  .base-drawer {
    &.offset {
      left: 60px;
    }
    .ant-spin-nested-loading {
      height: 100%;
    }
    .ant-spin-container {
      height: 100%;
      padding-top: 80px;
    }
    .ant-drawer-wrapper-body {
      overflow: hidden !important;
    }
    .ant-drawer-body {
      padding: 0;
      height: 100%;
    }
    &__body {
      padding: 0 20px!important;
      overflow: auto;
      height: 100%;
    }
    .header {
      width: 100%;
      height: 80px;
      padding: 0 20px;
      background: #fff;
      position: absolute;
      top: 0;
      .title {
        .font-size-24;
        font-weight: @font-weight-medium;
        color: @gray-9;
      }
    }
  }
</style>
